import { EventEntity } from '../schema/EventEntity';
import { EventsCache } from '../schema/EventsCache';
import { logCacheUpdateForDiagnosticsAsync } from 'owa-calendar-cache-diagnostics';

export function removeEvents<T extends EventEntity>(
    shouldRemove: (event: T) => boolean,
    cache: EventsCache<T>
): T[] {
    const { events } = cache;
    let eventsRemoved = 0;
    const removedEvents: T[] = [];
    for (let i = events.length - 1; i >= 0; i--) {
        const cacheItem = events[i];
        if (shouldRemove(cacheItem)) {
            removedEvents.push(cacheItem);

            events.splice(i, 1);
            eventsRemoved++;
        }
    }

    cleanLockedEventInfoForEvents(removedEvents, cache);

    // Log to diagnostics panel
    logCacheUpdateForDiagnosticsAsync({
        lockId: '',
        updateMessage: `Unloaded ${eventsRemoved} items from cache`,
    });

    return removedEvents.reverse();
}

function cleanLockedEventInfoForEvents(events: EventEntity[], cache: EventsCache<EventEntity>) {
    [...cache.locksInfo.keys()].forEach(lockId => {
        const lockInfo = cache.locksInfo.get(lockId);

        // For all the locks remove the corresponding lock for the events
        events.forEach(event => delete lockInfo.lockedEvents[event.Key]);
    });
}
